<template>
  <v-dialog
    v-model="active"
    max-width="500"
    @click:outside="$emit('close')"
  >
    <v-card>
      <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
      <v-card-title class="d-flex justify-content-center">
        <h5>Serviço #{{service.code}} foi salvo com sucesso!</h5>
      </v-card-title>
      <v-card-text class="text-center pb-5 pt-5">
        <i style="font-size:3rem;color:var(--green)" class="mdi mdi-check-decagram"></i>
      </v-card-text>
      <v-card-actions class="d-flex justify-content-center pb-5">
        <v-btn class="success" @click="$router.push({name:'Services-list'})">Retornar a lista de serviços</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:"ModalSavedService",
  props: {
    active:Boolean,
    service:Object
  }
}
</script>

<style scoped>
.close-icon {
  right: 10px;
  top: 10px;
  position: absolute;
  font-size: 1.3rem;
  cursor: pointer;
}
</style>